import { api } from "./api";

export async function enablePushNotifications(): Promise<string> {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return "Push is not supported on this device yet.";
  const key = await api.pushPublicKey();
  if (!key.enabled || !key.publicKey) return "Push is ready in the app, but VAPID keys are not configured on Cloudflare yet.";
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return "Notifications were not enabled.";
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(key.publicKey)
  });
  await api.subscribePush(subscription.toJSON());
  return "Push notifications are enabled.";
}

function urlBase64ToUint8Array(base64: string): ArrayBuffer {
  const padding = "=".repeat((4 - base64.length % 4) % 4);
  const output = atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  const array = new Uint8Array(output.length);
  for (let i = 0; i < output.length; i += 1) array[i] = output.charCodeAt(i);
  return array.buffer;
}
